import type {
  GraphEdgeSettings,
  GroupEdgeSettings,
  ProtocolEdgeType,
  TopologyEdgeSettings,
  TopologyGraphEdgeSettings,
} from '@ipfabric/utils';
import type { GraphState } from 'components/Graph/GraphState';
import type { Draft } from 'immer';

export const getEdgeFromGroupByProtocol = (
  draft: Draft<GraphState>,
  groupId: GroupEdgeSettings['id'] | null,
  protocolName?: ProtocolEdgeType,
): TopologyGraphEdgeSettings | undefined => {
  const { presetDraft } = draft.layoutSettings;
  // select group
  if (groupId !== null) {
    const foundGroup = presetDraft.edges.find(
      (group: GraphEdgeSettings): group is GroupEdgeSettings =>
        group.id === groupId && group.type === 'group',
    );
    if (foundGroup) {
      // group
      if (!protocolName) {
        return foundGroup;
      }
      // protocol in group
      return foundGroup.children.find(
        (protocol): protocol is TopologyEdgeSettings =>
          protocol.name === protocolName,
      );
    }
  }
  // protocol in Other protocols
  return presetDraft.edges.find(
    (item: TopologyGraphEdgeSettings) =>
      item.name === protocolName && item.type === 'protocol',
  );
};
